import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_3 = { class: "card-body border-top p-9" }
const _hoisted_4 = { class: "row mb-6" }
const _hoisted_5 = { class: "col-lg-6 fv-row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Tim Area", -1)
const _hoisted_7 = { class: "col-lg-6 fv-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Keterangan", -1)
const _hoisted_9 = { class: "card-body py-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-lg-12 col-form-label fw-bold py-0",
  style: {"font-size":"16px"}
}, "Sales Member", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-lg-12 col-form-label pt-0 pb-3",
  style: {"font-size":"12px","color":"#B7B7B7"}
}, "Manajemen Data Member ", -1)
const _hoisted_12 = { class: "col-lg-12" }
const _hoisted_13 = { class: "table-responsive" }
const _hoisted_14 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"25%"},
      class: "text-center"
    }, "Nama Sales"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"15%"},
      class: "text-center"
    }, "Jumlah Sekolah"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"20%"},
      class: "text-center"
    }, "Pendapatan Terbayar"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"20%"},
      class: "text-center"
    }, "Pendapatan Belum Terbayar"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"20%"},
      class: "text-center"
    }, "Total Pendapatan")
  ])
], -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "text-left" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("th", {
  style: {"width":"25%"},
  class: "text-center"
}, "Jumlah", -1)
const _hoisted_25 = {
  style: {"width":"15%"},
  class: "text-center"
}
const _hoisted_26 = {
  style: {"width":"20%"},
  class: "text-center"
}
const _hoisted_27 = {
  style: {"width":"20%"},
  class: "text-center"
}
const _hoisted_28 = {
  style: {"width":"20%"},
  class: "text-center"
}
const _hoisted_29 = { key: 2 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "7",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "card-body py-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-lg-12 col-form-label fw-bold py-0",
  style: {"font-size":"16px"}
}, "Wilayah Sales Area", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-lg-12 col-form-label pt-0 pb-3",
  style: {"font-size":"12px","color":"#B7B7B7"}
}, "Manajemen Data Wilayah ", -1)
const _hoisted_35 = { class: "table-responsive" }
const _hoisted_36 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"25%"},
      class: "text-center"
    }, "Provinsi"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"15%"},
      class: "text-center"
    }, "Sekolah"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"12%"},
      class: "text-center"
    }, "Leads"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"12%"},
      class: "text-center"
    }, "Proses"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"12%"},
      class: "text-center"
    }, "Closing"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"12%"},
      class: "text-center"
    }, "Live "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"12%"},
      class: "text-center"
    }, "Cancel ")
  ])
], -1)
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "text-center" }
const _hoisted_40 = { class: "text-center" }
const _hoisted_41 = { class: "text-center" }
const _hoisted_42 = { class: "text-center" }
const _hoisted_43 = { class: "text-center" }
const _hoisted_44 = { class: "text-center" }
const _hoisted_45 = { class: "text-center" }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "7",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_48 = [
  _hoisted_47
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        id: "kt_account_profile_details_form",
        class: "form",
        novalidate: "novalidate",
        onSubmit: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveChanges1()))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "name",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Tim Area",
                  modelValue: _ctx.edit.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.edit.name) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "note",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Keterangan",
                  modelValue: _ctx.edit.note,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.edit.note) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                class: "btn me-3 border rounded-lg mb-2",
                style: {"background-color":"#FFFFFF"},
                type: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ShowFilter && _ctx.ShowFilter(...args)))
              }, " Filter ")
            ]),
            (_ctx.edit.showFilter == true)
              ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 0,
                  class: "mb-2 col-lg-4",
                  "picker-options": _ctx.pickerOptions,
                  modelValue: _ctx.edit.dateAll,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.edit.dateAll) = $event)),
                  type: "monthrange",
                  "start-placeholder": "Bulan Awal",
                  "end-placeholder": "Bulan Akhir",
                  "value-format": "YYYY-MM",
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.pilihTanggalAll()))
                }, null, 8, ["picker-options", "modelValue"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("table", _hoisted_14, [
                _hoisted_15,
                (_ctx.edit.members.length)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.edit.members, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", _hoisted_17, _toDisplayString(item.salesName), 1),
                          _createElementVNode("td", _hoisted_18, _toDisplayString(item.globalSchools), 1),
                          _createElementVNode("td", _hoisted_19, " Rp. " + _toDisplayString(_ctx.formatPrice(item.invoicePaid)), 1),
                          _createElementVNode("td", _hoisted_20, " Rp. " + _toDisplayString(_ctx.formatPrice(item.invoiceUnpaid)), 1),
                          _createElementVNode("td", _hoisted_21, " Rp. " + _toDisplayString(_ctx.formatPrice(item.totalInvoices)), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.edit.members.length)
                  ? (_openBlock(), _createElementBlock("thead", _hoisted_22, [
                      _createElementVNode("tr", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.edit.totalSekolah), 1),
                        _createElementVNode("th", _hoisted_26, "Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.edit.totalPendapatanTerbayar)), 1),
                        _createElementVNode("th", _hoisted_27, "Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.edit.totalPendapatanBelumTerbayar)), 1),
                        _createElementVNode("th", _hoisted_28, "Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.edit.totalPendapatan)), 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_29, _hoisted_31))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("table", _hoisted_36, [
                _hoisted_37,
                (_ctx.edit.regions.length)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_38, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.edit.regions, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", _hoisted_39, _toDisplayString(item.province), 1),
                          _createElementVNode("td", _hoisted_40, _toDisplayString(item.totalSchools), 1),
                          _createElementVNode("td", _hoisted_41, _toDisplayString(item.leads), 1),
                          _createElementVNode("td", _hoisted_42, _toDisplayString(item.process), 1),
                          _createElementVNode("td", _hoisted_43, _toDisplayString(item.closing), 1),
                          _createElementVNode("td", _hoisted_44, _toDisplayString(item.live), 1),
                          _createElementVNode("td", _hoisted_45, _toDisplayString(item.cancel), 1)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_46, _hoisted_48))
              ])
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}